import styled from 'styled-components';

import {
  baseBoxShadowFocus,
  borderRadius8,
} from 'approot/shared/styles/borders.style';
import {
  coolGrey1,
  grey10,
  grey7,
  grey9,
  purple1,
  purple7,
} from 'approot/shared/styles/colours.style';
import { rem } from 'approot/shared/style';
import {
  spacing16,
  spacing4,
  spacing8,
} from 'approot/shared/styles/spacing.style';
import {
  Heading16,
  PStyled,
  SmallStyled,
} from 'approot/shared/styles/typography.style';
import { BoxList } from 'approot/shared/design-system/box/box.style';

export const HistoryListItemTrigger = styled.button`
  background: transparent;
  border: none;
  border-radius: ${rem(borderRadius8)};
  left: 0;
  margin: 0;
  padding: 0;
  text-align: left;
  bottom: 0;
  right: 0;
  top: 0;
  width: 100%;

  &:focus {
    box-shadow: inset ${baseBoxShadowFocus};
    outline: 0;
  }
`;

export const HistoryListTitle = styled(Heading16).attrs({
  as: 'h2',
  marginBottom: 0,
})``;

export const HistoryListListText = styled(PStyled).attrs({
  marginBottom: 0,
})``;

export const HistoryListSubText = styled(SmallStyled).attrs({
  colour: grey7,
  marginBottom: 0,
})``;

export const HistoryListUser = styled(SmallStyled).attrs({
  colour: grey10,
})`
  display: flex;
  flex-wrap: wrap;
  gap: ${rem(spacing4)};
  margin-bottom: 0;
`;

type HistoryListItemProps = {
  $isActive: boolean;
};
export const HistoryListItem = styled.li<HistoryListItemProps>`
  position: relative;

  &:hover {
    ${HistoryListItemTrigger} {
      cursor: pointer;
      background-color: ${coolGrey1};
    }

    ${HistoryListItemTrigger}:disabled {
      background-color: inherit;
      cursor: not-allowed;
    }
  }

  ${({ $isActive }) =>
    $isActive &&
    `
    background-color: ${purple1};
    border-radius: ${rem(borderRadius8)};

    ${HistoryListListText}, ${HistoryListSubText}, ${HistoryListUser} {
      color: ${purple7};
    }
  `}
`;

export const HistoryListItemContent = styled.div`
  color: ${grey9};
  padding: ${rem(spacing8)};
  position: relative;
`;

export const HistoryList = styled(BoxList)`
  & > li {
    margin-bottom: ${rem(spacing16)};
  }
  ${HistoryListItem} {
    margin-bottom: 0;
  }
`;
